export default __webpack_public_path__ + "static/media/whatCard3.e0225064.webp";